import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import {
    Forfait,
    ForfaitCreateInput,
    ForfaitFilters,
    ForfaitListResponse,
    ForfaitResponse,
    ForfaitSelectOption,
    ForfaitUpdateInput,
} from '../types/forfait';
import { BaseApiService } from './base-api.service';

export class ForfaitService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.FORFAITS.BASE, axios);
  }

  async getForfaits(filters: ForfaitFilters = {}): Promise<ForfaitListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated<Forfait>({ page, limit, ...rest });
  }

  async getForfaitById(id: number): Promise<ForfaitResponse> {
    return this.get<ForfaitResponse>(`/${id}`);
  }

  async createForfait(data: ForfaitCreateInput): Promise<ForfaitResponse> {
    return this.post<ForfaitResponse, ForfaitCreateInput>('', data);
  }

  async updateForfait(id: number, data: ForfaitUpdateInput): Promise<ForfaitResponse> {
    return this.put<ForfaitResponse, ForfaitUpdateInput>(`/${id}`, data);
  }

  async deleteForfait(id: number): Promise<ForfaitResponse> {
    return this.delete<ForfaitResponse>(`/${id}`);
  }

  async getForfaitOptions(): Promise<ForfaitSelectOption[]> {
    return this.get<ForfaitSelectOption[]>('/select');
  }
}
